import React from 'react';
import PropTypes from 'prop-types';

import styles from './Card.module.scss';

const Card = ({ title, content }) => (
    <div className={styles['card-component']}>
        {title ? <p className={styles["card-title"]}>{title}</p> : null}
        {content}
    </div>
);

Card.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
};

export default Card;
